import { BrowserRouter, Routes, Route, Outlet } from 'react-router'
import { Suspense } from 'react'
import OrderDetails from '../../order-details/OrderDetails'
import Loader from '../loader/Loader'
import Stack from '@mui/material/Stack'
import { Header } from '../header/Header'
import Success from '../../payment-response/Success'
import Footer from '../footer/Footer'
import Done from '../../payment-response/Done'

// Hoisted to module level to prevent remounting on re-renders
const Layout = () => {
    return (
        <Stack
            sx={{
                minHeight: '100vh',
                width: '100%',
                backgroundColor: '#D1D9E2',
                display: 'flex',
                flexDirection: 'column'
            }}>
            <Header />
            <Stack sx={{ flex: 1 }}>
                <Outlet />
            </Stack>
            <Footer />
        </Stack>
    )
}

const AppRouter = () => {
    return (
        <BrowserRouter basename="/">
            <Suspense fallback={<Loader />}>
                <Routes>
                    {/* ponytail: outside Layout — this renders inside the payment iframe, no header/footer */}
                    <Route path="/payment-response/done" element={<Done />} />
                    <Route element={<Layout />}>
                        <Route path="/payment" element={<OrderDetails />} />
                        <Route path="/detail" element={<OrderDetails />} />
                        <Route path="/payment-response/success" element={<Success />} />
                        <Route path="/" element={<OrderDetails />} index />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}

export default AppRouter
